import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import { Church } from '@asambleas-models/church.model';
import { TABLES_CONFIG } from '@asambleas-env/environment';
import { Member } from '@asambleas-models/member.model';
import { MemberService } from '@asambleas-services/member/member.service';
import { GeneralService } from '@asambleas-services/general/general.service';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';

@Component({
    selector: 'app-member-list',
    templateUrl: './member-list.component.html',
    styleUrls: ['./member-list.component.css']
})
export class MemberListComponent implements OnInit {

    ROWS = TABLES_CONFIG.ROW_NUMBER

    // Defines if all the needed resources has load
    resourcesHasLoaded: boolean = false;
    isAuthorized = true;
    allMembers: Member[] = [];

    displayedColumns = ['member', 'birthdate', 'district', 'sectional', 'church', 'type', 'id'];
    dataSource = new MatTableDataSource(this.allMembers);

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private memberService: MemberService,
        private generalService: GeneralService,
        private _feedback: UserFeedbackService
    ) {
        this.loadMembers();
    }

    ngOnInit() {
        //this.dataSource = new MatTableDataSource(this.allMembers);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    loadMembers() {
        this.memberService.getMembers().subscribe(
            (data: Member[]) => {
                this.allMembers = data;
                this.allMembers.forEach(member => {
                    this.generalService.members[member.id] = member;
                });

                this.dataSource = new MatTableDataSource(this.allMembers);

                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.resourcesHasLoaded = true;
            },
            (error) => {
                console.log('error', error);
                this.isAuthorized = false;
                this.resourcesHasLoaded = true;
            });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    downloadUsers() {
        csvOptions['headers'] = ['Nombre', 'Email', 'Sexo', 'Seccional', 'Distrito', 'Número de documento', 'Tipo de documento', 'Fecha de nacimiento', 'Lugar de nacimiento', 'Estado civil', 'Direción', 'Ciudad', 'Es académico', 'Iglesia'];

        //console.log('ministros a imprimir', this.dataSource.data);

        const csvMembers = this.dataSource.data.map((member) => {
            return {
                name: `${member.name} ${member.second_name} ${member.surname} ${member.second_surname}`,
                email: member.email,
                gender: member.gender,
                sectional: member.sectional.name,
                district: member.district.name,
                document_number: member.document_number,
                document_type: this.generalService.getDocumentType(member.document_type),
                birthdate: member.birthdate,
                birthplace: member.birthplace,
                civil_status: this.generalService.getCivilStatus(member.civil_status),
                residence_address: member.residence_address,
                residence_city: member.residence_city,
                is_academic: member.is_academic ? 'Si' : 'No',
                church: member.church.name,
            }
        })

        const data = new Angular5Csv(csvMembers, 'Miembros', csvOptions);

    }

    filtrarByChurches(data: Church[]) {
        this.dataSource.data = this.allMembers.filter((member) => {
            let exist = data.find((church) => {
                return church.id == member.church.id;
            })
            return exist;
        })
    }

    changeIsAcademic(member: any) {
        this.memberService.changeIsAcademic(member).then(resp => {
            if (resp) {
                member.is_academic = !member.is_academic
                this._feedback.openSnackbar({ message: 'Se modificó con exito.' })
            }
        }, error => {
            console.log(error)
        })
    }

}

const csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true
};



// WEBPACK FOOTER //
// ./src/app/admin/pages/members/member-list/member-list.component.ts